module.exports = __webpack_public_path__ + "static/media/btn-approve.c51474c6.png";